import { atom } from 'jotai';

/**
 * Determines if the user is logged in
 * Used by the CoreAuthProvider to determine if the user is logged in.
 */
const isLoggedInAtom = atom<boolean | null>(null);
isLoggedInAtom.debugLabel = 'isLoggedInAtom';

/**
 * Determines if the authentication is loading based on if the user is logged in is null
 */
const isLoadingAuthenticationAtom = atom<boolean>((get) => get(isLoggedInAtom) === null);
isLoadingAuthenticationAtom.debugLabel = 'isLoadingAuthenticationAtom';

export { isLoadingAuthenticationAtom, isLoggedInAtom };
